import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ActionButtonsGroup, ButtonWithLoader } from 'shared/components';

interface UpdateFormActionButtonsProps {
    onComplete?: () => void,
    onSubmit: () => void,
    isLoading: boolean,
    disabledSubmit?: boolean
}

export default function UpdateFormActionButtons({
    onComplete,
    onSubmit,
    isLoading,
    disabledSubmit
}: UpdateFormActionButtonsProps) {
    const { t } = useTranslation('common');

    return (
        <ActionButtonsGroup>
            { onComplete && (
                <Button variant="outlined"
                    size="small"
                    onClick={ onComplete }
                >
                    { t('cancel') }
                </Button>
            ) }
            <ButtonWithLoader variant="contained"
                size="small"
                onClick={ onSubmit }
                loading={ isLoading }
                disabled={ disabledSubmit }
            >
                { t('save') }
            </ButtonWithLoader>
        </ActionButtonsGroup>
    );
}
